import { CSSProperties, ReactElement } from "react";
import { ReactComponent as PlusIcon } from "@jnctn/icons/cool-icons/Edit/Add_Plus.svg";
import { ReactComponent as UserIcon } from "@jnctn/icons/cool-icons/User/User_01.svg";
import { ReactComponent as UserTwoIcon } from "@jnctn/icons/cool-icons/User/User_02.svg";
import { ReactComponent as UserThreeIcon } from "@jnctn/icons/cool-icons/User/User_03.svg";
import { ReactComponent as UsersGroupIcon } from "@jnctn/icons/cool-icons/User/Users_Group.svg";
import { ReactComponent as UserTickIcon } from "@jnctn/icons/cool-icons/User/User_Check.svg";
import { ReactComponent as UserPlusIcon } from "@jnctn/icons/cool-icons/User/User_Add.svg";
import { ReactComponent as UserMinusIcon } from "@jnctn/icons/cool-icons/User/User_Remove.svg";
import { ReactComponent as UserCircle } from "@jnctn/icons/cool-icons/User/User_Circle.svg";
import { ReactComponent as SquareTickLargeIcon } from "@jnctn/icons/cool-icons/File/Square_Check_Large.svg";
import { ReactComponent as UserCrossIcon } from "@jnctn/icons/cool-icons/User/User_Close.svg";
import { ReactComponent as ExternalLinkIcon } from "@jnctn/icons/cool-icons/Interface/External_Link.svg";
import { ReactComponent as VisibleEyeIcon } from "@jnctn/icons/cool-icons/Interface/Visible_Eye.svg";
import { ReactComponent as SettingsGear } from "@jnctn/icons/cool-icons/Interface/Settings.svg";
import { ReactComponent as ImageIcon } from "@jnctn/icons/cool-icons/Media/Image_01.svg";
import { ReactComponent as ImageLargeIcon } from "@jnctn/icons/cool-icons/Media/Image_Large.svg";
import { ReactComponent as PlayIcon } from "@jnctn/icons/cool-icons/Media/Play.svg";
import { ReactComponent as ArrowRightIcon } from "@jnctn/icons/cool-icons/Arrow/Chevron_Right.svg";
import { ReactComponent as ArrowRightMDIcon } from "@jnctn/icons/cool-icons/Arrow/Chevron_Right_MD.svg";
import { ReactComponent as ArrowRightLGIcon } from "@jnctn/icons/cool-icons/Arrow/Arrow_Right_LG.svg";
import { ReactComponent as ArrowLeftIcon } from "@jnctn/icons/cool-icons/Arrow/Chevron_Left.svg";
import { ReactComponent as ArrowLeftMDIcon } from "@jnctn/icons/cool-icons/Arrow/Chevron_Left_MD.svg";
import { ReactComponent as ArrowRotateRightIcon } from "@jnctn/icons/cool-icons/Arrow/Arrow_Rotate_Right.svg";
import { ReactComponent as ArrowRotateLeftIcon } from "@jnctn/icons/cool-icons/Arrow/Arrow_Rotate_Left.svg";
import { ReactComponent as ArrowRotateFileRightIcon } from "@jnctn/icons/cool-icons/Arrow/Arrow_Rotate_File_Right.svg";
import { ReactComponent as ArrowRotateFileLeftIcon } from "@jnctn/icons/cool-icons/Arrow/Arrow_Rotate_File_Left.svg";
import { ReactComponent as ArrowUpIcon } from "@jnctn/icons/cool-icons/Arrow/Chevron_Up.svg";
import { ReactComponent as ArrowDownIcon } from "@jnctn/icons/cool-icons/Arrow/Chevron_Down.svg";
import { ReactComponent as CloseIcon } from "@jnctn/icons/cool-icons/Menu/Close_MD.svg";
import { ReactComponent as CloseLargeIcon } from "@jnctn/icons/cool-icons/Menu/Close_LG.svg";
import { ReactComponent as ListIcon } from "@jnctn/icons/cool-icons/Edit/List_Unordered.svg";
import { ReactComponent as BuildingOutlineIcon } from "@jnctn/icons/cool-icons/Navigation/Building_04.svg";
import { ReactComponent as EditIconPencilLine1 } from "@jnctn/icons/cool-icons/Edit/Edit_Pencil_Line_01.svg";
import { ReactComponent as Hexagon1 } from "@jnctn/icons/cool-icons/Custom/hexagon_01.svg";
import { ReactComponent as ProfilePhotoInvalid } from "@jnctn/icons/cool-icons/Custom/Profile_Photo_Invalid.svg";
import { ReactComponent as ProfilePhotoValid } from "@jnctn/icons/cool-icons/Custom/Profile_Photo_Valid.svg";
import { ReactComponent as TrashFull } from "@jnctn/icons/cool-icons/Interface/Trash_Full.svg";
import { ReactComponent as Crop } from "@jnctn/icons/cool-icons/Edit/Crop.svg";
import { ReactComponent as ProcessingCsvLarge } from "@jnctn/icons/cool-icons/Custom/Processing_Csv_Large.svg";
import { ReactComponent as ImportRecordsLarge } from "@jnctn/icons/cool-icons/Custom/Import_Records_Large.svg";
import { ReactComponent as NewCredentialsLarge } from "@jnctn/icons/cool-icons/Custom/New_Credentials_Large.svg";
import { ReactComponent as NoResultsLarge } from "@jnctn/icons/cool-icons/Custom/No_Results_Large.svg";
import { ReactComponent as CardCheckLarge } from "@jnctn/icons/cool-icons/Custom/Card_Check_Large.svg";
import { ReactComponent as ArrowExpandIcon } from "@jnctn/icons/cool-icons/Arrow/Expand.svg";
import { ReactComponent as ArrowShrinkIcon } from "@jnctn/icons/cool-icons/Arrow/Shrink.svg";
import { ReactComponent as LogoPOS } from "@jnctn/icons/cool-icons/Logo/logo-POS.svg";
import { ReactComponent as LogoNEG } from "@jnctn/icons/cool-icons/Logo/logo-NEG.svg";
import { ReactComponent as RequirementType } from "@jnctn/icons/cool-icons/Custom/Requirement_Type.svg";
import { ReactComponent as OctagonWarning } from "@jnctn/icons/cool-icons/Warning/Octagon_Warning.svg";
import { ReactComponent as CircleWarning } from "@jnctn/icons/cool-icons/Warning/Circle_Warning.svg";
import { ReactComponent as TriangleWarning } from "@jnctn/icons/cool-icons/Warning/Triangle_Warning.svg";
import { ReactComponent as WarningInfo } from "@jnctn/icons/cool-icons/Warning/Info.svg";
import { ReactComponent as CameraIcon } from "@jnctn/icons/cool-icons/System/Camera.svg";
import { ReactComponent as WarningCircleHelp } from "@jnctn/icons/cool-icons/Warning/Circle_Help.svg";
import { ReactComponent as ClockIcon } from "@jnctn/icons/cool-icons/Calendar/Clock.svg";
import { ReactComponent as ClockSolidIcon } from "@jnctn/icons/cool-icons/Calendar/Clock_Solid.svg";
import { ReactComponent as ClockWarningOutlineIcon } from "@jnctn/icons/cool-icons/Calendar/Clock_Outline_Warning.svg";
import { ReactComponent as ClockCrossOutlineIcon } from "@jnctn/icons/cool-icons/Calendar/Clock_Outline_Cross.svg";
import { ReactComponent as CalendarIcon } from "@jnctn/icons/cool-icons/Calendar/Calendar.svg";
import { ReactComponent as CalendarCloseIcon } from "@jnctn/icons/cool-icons/Calendar/Calendar_Close.svg";
import { ReactComponent as CalendarDaysIcon } from "@jnctn/icons/cool-icons/Calendar/Calendar_Days.svg";
import { ReactComponent as CalendarEventIcon } from "@jnctn/icons/cool-icons/Calendar/Calendar_Event.svg";
import { ReactComponent as TimerIcon } from "@jnctn/icons/cool-icons/Calendar/Timer.svg";
import { ReactComponent as File } from "@jnctn/icons/cool-icons/File/File_Document.svg";
import { ReactComponent as FileUploadIcon } from "@jnctn/icons/cool-icons/File/File_Upload.svg";
import { ReactComponent as FileUploadLargeIcon } from "@jnctn/icons/cool-icons/File/File_Upload_Large.svg";
import { ReactComponent as EmptyTileLargeIcon } from "@jnctn/icons/cool-icons/Custom/Empty_Tile_Large.svg";
import { ReactComponent as DownloadIcon } from "@jnctn/icons/cool-icons/Interface/Download.svg";
import { ReactComponent as CloudDownloadIcon } from "@jnctn/icons/cool-icons/File/Cloud_Download.svg";
import { ReactComponent as NavDashboardIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Dashboard.svg";
import { ReactComponent as NavOnboardingIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Onboarding.svg";
import { ReactComponent as NavMembersIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Members.svg";
import { ReactComponent as NavCredentialsIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Credentials.svg";
import { ReactComponent as NavLocationsIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Locations.svg";
import { ReactComponent as NavLocationDashboardIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Location_Dashboard.svg";
import { ReactComponent as NavLocationLiveViewIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Location_Liveview.svg";
import { ReactComponent as NavLocationNewIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Location_New.svg";
import { ReactComponent as NavOrganisationsIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Organisations.svg";
import { ReactComponent as NavCardsIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Cards.svg";
import { ReactComponent as NavMembersNewIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Members_New.svg";
import { ReactComponent as NavMembersImportIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Members_Import.svg";
import { ReactComponent as NavOrganisationsNewIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Organisations_New.svg";
import { ReactComponent as NavCredentialsNewIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Credentials_New.svg";
import { ReactComponent as NavCredentialsAssignIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Credentials_Assign.svg";
import { ReactComponent as NavCardsNewCardIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Cards_New_Card.svg";
import { ReactComponent as NavCardsNewTemplateIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Cards_New_Template.svg";
import { ReactComponent as NavCardsTemplatesIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Cards_Templates.svg";
import { ReactComponent as NavCardsOrdersIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Cards_Orders.svg";
import { ReactComponent as NavTemplatesIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Templates.svg";
import { ReactComponent as SelectedPinIcon } from "@jnctn/icons/cool-icons/Custom/Selected_Pin.svg";
import { ReactComponent as ShoppingCartIcon } from "@jnctn/icons/cool-icons/Interface/Shopping_Cart_01.svg";
import { ReactComponent as CheckIcon } from "@jnctn/icons/cool-icons/Interface/Check.svg";
import { ReactComponent as MenuHamburgerIcon } from "@jnctn/icons/cool-icons/Menu/Hamburger_LG.svg";
import { ReactComponent as MoreHorizontalIcon } from "@jnctn/icons/cool-icons/Menu/More_Horizontal.svg";
import { ReactComponent as MoreVerticalIcon } from "@jnctn/icons/cool-icons/Menu/More_Vertical.svg";
import { ReactComponent as LogoIcon } from "@jnctn/icons/cool-icons/Logo/logo-icon.svg";
import { ReactComponent as CroppedLogoIcon } from "@jnctn/icons/cool-icons/Logo/logo-icon-cropped.svg";
import { ReactComponent as NavRolesIcon } from "@jnctn/icons/cool-icons/Custom/Nav_Roles.svg";
import { ReactComponent as ProcessingOrderIcon } from "@jnctn/icons/cool-icons/Custom/Processing_Order.svg";
import { ReactComponent as NoteIcon } from "@jnctn/icons/cool-icons/File/Note.svg";
import { ReactComponent as NotebookIcon } from "@jnctn/icons/cool-icons/File/Notebook.svg";
import { ReactComponent as PeopleCrowdIcon } from "@jnctn/icons/people-crowd.svg";
import { ReactComponent as PeopleCrowdOutlineIcon } from "@jnctn/icons/people-crowd-outline.svg";
import { ReactComponent as PeopleGroupIcon } from "@jnctn/icons/people-group.svg";
import { ReactComponent as PeopleGroupOutlineIcon } from "@jnctn/icons/people-group-outline.svg";
import { ReactComponent as DashboardIcon } from "@jnctn/icons/dashboard.svg";
import { ReactComponent as CircleTick } from "@jnctn/icons/circle-tick.svg";
import { ReactComponent as CircleCheckSolid } from "@jnctn/icons/cool-icons/Warning/Circle_Check_Solid.svg";
import { ReactComponent as LogoutIcon } from "@jnctn/icons/cool-icons/Interface/Log_Out.svg";
import { ReactComponent as MenuGridBigIcon } from "@jnctn/icons/cool-icons/Menu/More_Grid_Big.svg";
import { ReactComponent as EditTableIcon } from "@jnctn/icons/cool-icons/Edit/Table.svg";
import { ReactComponent as PaperPlaneIcon } from "@jnctn/icons/cool-icons/Communication/Paper_Plane.svg";
import { ReactComponent as MailIcon } from "@jnctn/icons/cool-icons/Communication/Mail.svg";
import { ReactComponent as UserCardIcon } from "@jnctn/icons/cool-icons/User/User_Card_ID.svg";
import { ReactComponent as UserCardSlimIcon } from "@jnctn/icons/cool-icons/User/User_Card_ID_Slim.svg";
import { ReactComponent as RemoveMinusIcon } from "@jnctn/icons/cool-icons/Edit/Remove_Minus.svg";
import { ReactComponent as CredentialCardIcon } from "@jnctn/icons/cool-icons/Custom/Credential_Card.svg";
import { ReactComponent as SearchIcon } from "@jnctn/icons/cool-icons/Interface/Search_Magnifying_Glass.svg";
import { ReactComponent as FilterOptionsIcon } from "@jnctn/icons/cool-icons/Interface/Filter_Options.svg";
import { ReactComponent as ArrowCaretRightIcon } from "@jnctn/icons/cool-icons/Arrow/Caret_Right_SM.svg";
import { ReactComponent as ArrowCaretLeftIcon } from "@jnctn/icons/cool-icons/Arrow/Caret_Left_SM.svg";
import { ReactComponent as ArrowCaretDownIcon } from "@jnctn/icons/cool-icons/Arrow/Caret_Down_SM.svg";
import { ReactComponent as ArrowsHorizontalLeftTopGreyIcon } from "@jnctn/icons/cool-icons/Arrow/Arrows_Horizontal_Left_Top_Grey.svg";
import { ReactComponent as ArrowCaretUpIcon } from "@jnctn/icons/cool-icons/Arrow/Caret_Up_SM.svg";
import { ReactComponent as CredentialIssuanceFinishIcon } from "@jnctn/icons/cool-icons/Custom/Credential-Issuance-Finish.svg";
import { ReactComponent as QRCodeIcon } from "@jnctn/icons/cool-icons/Custom/QR_Code.svg";
import { ReactComponent as AllCheckedIcon } from "@jnctn/icons/cool-icons/Interface/Check_All.svg";
import { ReactComponent as WalletCredentialIdentityIcon } from "@jnctn/icons/crx/crx_identity_icon.svg";
import { ReactComponent as WalletCredentialAssessmentIcon } from "@jnctn/icons/crx/crx_assessment_icon.svg";
import { ReactComponent as WalletCredentialUnitStandardIcon } from "@jnctn/icons/crx/crx_unit_standard_icon.svg";
import { ReactComponent as WalletCredentialTrainingIcon } from "@jnctn/icons/crx/crx_training_icon.svg";
import { ReactComponent as WalletCredentialInductionIcon } from "@jnctn/icons/crx/crx_induction_icon.svg";
import { ReactComponent as WalletCredentialAddressIcon } from "@jnctn/icons/crx/crx_address_icon.svg";
import { ReactComponent as WalletCredentialEquipmentIcon } from "@jnctn/icons/crx/crx_equipment_icon.svg";
import { ReactComponent as WalletCredentialCourseIcon } from "@jnctn/icons/crx/crx_course_icon.svg";
import { ReactComponent as WalletCredentialLicenseIcon } from "@jnctn/icons/crx/crx_license_icon.svg";
import { ReactComponent as WalletCredentialDocumentIcon } from "@jnctn/icons/crx/crx_document_icon.svg";
import { ReactComponent as WalletCredentialMembershipIcon } from "@jnctn/icons/crx/crx_membership_icon.svg";
import { ReactComponent as WalletCredentialMissingIcon } from "@jnctn/icons/crx/crx_missing_icon.svg";
import { ReactComponent as SortAscendingIcon } from "@jnctn/icons/cool-icons/Edit/Sort_Ascending.svg";
import { ReactComponent as SortDescendingIcon } from "@jnctn/icons/cool-icons/Edit/Sort_Descending.svg";
import { ReactComponent as StatusBadgeIcon } from "@jnctn/icons/cool-icons/Custom/Status_Badge.svg";
import { ReactComponent as StatusBadgeLeftIcon } from "@jnctn/icons/cool-icons/Custom/Status_Badge_Left.svg";
import { ReactComponent as CircleBadgeCheckOutlineIcon } from "@jnctn/icons/cool-icons/Warning/Circle_Badge_Check_Outline.svg";
import { ReactComponent as CircleBadgeCheckSolidIcon } from "@jnctn/icons/cool-icons/Warning/Circle_Badge_Check_Solid.svg";
import { ReactComponent as CircleCheckIcon } from "@jnctn/icons/cool-icons/Warning/Circle_Check.svg";
import { ReactComponent as CircleCloseIcon } from "@jnctn/icons/cool-icons/Edit/Close_Circle.svg";
import { ReactComponent as CircleBadgeWarningOutlineIcon } from "@jnctn/icons/cool-icons/Warning/Circle_Badge_Warning_Outline.svg";
import { ReactComponent as CircleBackslashIcon } from "@jnctn/icons/cool-icons/Warning/Circle_Backslash.svg";
import { ReactComponent as ShieldCheckIcon } from "@jnctn/icons/cool-icons/Warning/Shield_Badge_Check.svg";
import { ReactComponent as DragVerticalIcon } from "@jnctn/icons/cool-icons/Interface/Drag_Vertical.svg";
import { ReactComponent as LockIcon } from "@jnctn/icons/cool-icons/Interface/Lock.svg";
import { ReactComponent as IssueSuccessIcon } from "@jnctn/icons/cool-icons/Custom/Issue_Success.svg";
import { ReactComponent as ArchiveIcon } from "@jnctn/icons/cool-icons/File/Archive.svg";
import { ReactComponent as UndoIcon } from "@jnctn/icons/cool-icons/Edit/Undo.svg";
import { ReactComponent as MapPinIcon } from "@jnctn/icons/cool-icons/Navigation/Map_Pin.svg";
import { ReactComponent as PageMarkerDot } from "@jnctn/icons/cool-icons/Navigation/Page_Marker_Dot.svg";
import { ReactComponent as PageMarkerActive } from "@jnctn/icons/cool-icons/Navigation/Page_Marker_Active.svg";
import { ReactComponent as DarkerIssueSuccess } from "@jnctn/icons/cool-icons/Custom/Darker-Issue-Success.svg";
import { ReactComponent as RulesetIcon } from "@jnctn/icons/cool-icons/Custom/Rulesets.svg";
import { ReactComponent as ChecklistCheckedIcon } from "@jnctn/icons/cool-icons/Custom/Checklist_Checked.svg";
import { ReactComponent as ViewEmptyPanelSelectionCredentialIcon } from "@jnctn/icons/cool-icons/Custom/View_Empty_Panel_Selection_Credential.svg";
import { ReactComponent as ViewEmptyPanelSelectionRecipientIcon } from "@jnctn/icons/cool-icons/Custom/View_Empty_Panel_Selection_Recipient.svg";
import { ReactComponent as FileDownloadIcon } from "@jnctn/icons/cool-icons/File/File_Download.svg";
import { ReactComponent as CopyIcon } from "@jnctn/icons/cool-icons/Edit/Copy.svg";
import { ReactComponent as CheckboxInnerTickIcon } from "@jnctn/icons/cool-icons/Interface/Checkbox_Inner_Tick.svg";
import { ReactComponent as ArrowReload } from "@jnctn/icons/cool-icons/Arrow/Arrows_Reload_01.svg";
import { ReactComponent as IssueCredentialIcon } from "@jnctn/icons/cool-icons/Custom/Issue_Credential.svg";
import { ReactComponent as ArrowResetIcon } from "@jnctn/icons/cool-icons/Arrow/Arrow_Reset.svg";
import { ReactComponent as LocationRulesetIcon } from "@jnctn/icons/cool-icons/Custom/Location_Ruleset.svg";
import { ReactComponent as MapPinFilledIcon } from "@jnctn/icons/cool-icons/Navigation/Map_Pin_Filled.svg";
import { ReactComponent as CredentialIssuanceHexIcon } from "@jnctn/icons/cool-icons/Custom/Credential_Issuance_Hex.svg";
import { ReactComponent as WorkerIcon } from "@jnctn/icons/cool-icons/Custom/Worker.svg";
import { ReactComponent as EventRulesetIcon } from "@jnctn/icons/cool-icons/Custom/Event_Ruleset.svg";
import { IconName } from "@jnctn/types/IconName";

export type IconColor =
  | "black"
  | "white"
  | "inherit"
  | "saphire"
  | "ocean"
  | "green"
  | "orange"
  | "red"
  | "neutral"
  | "neutral-dark"
  | "neutral-light";

// IconName lives in @jnctn/types so "hooks"-tagged libs can use it without depending on this "ui"-tagged lib
export type { IconName } from "@jnctn/types/IconName";

interface IconProps {
  className?: string;
  "aria-label"?: string;
  strokeWidth?: number;
  style?: CSSProperties;
}

export const iconMap: {
  [key in IconName]: (props: IconProps) => ReactElement;
} = {
  "arrow-right": (props: IconProps) => <ArrowRightIcon {...props} />,
  "arrow-right-md": (props: IconProps) => <ArrowRightMDIcon {...props} />,
  "arrow-left": (props: IconProps) => <ArrowLeftIcon {...props} />,
  "arrow-left-md": (props: IconProps) => <ArrowLeftMDIcon {...props} />,
  "arrow-rotate-right": (props: IconProps) => (
    <ArrowRotateRightIcon {...props} />
  ),
  "arrow-rotate-left": (props: IconProps) => <ArrowRotateLeftIcon {...props} />,
  "arrow-rotate-file-right": (props: IconProps) => (
    <ArrowRotateFileRightIcon {...props} />
  ),
  "arrow-rotate-file-left": (props: IconProps) => (
    <ArrowRotateFileLeftIcon {...props} />
  ),
  "arrow-down": (props: IconProps) => <ArrowDownIcon {...props} />,
  "arrow-up": (props: IconProps) => <ArrowUpIcon {...props} />,
  "arrow-caret-right": (props: IconProps) => <ArrowCaretRightIcon {...props} />,
  "arrow-caret-left": (props: IconProps) => <ArrowCaretLeftIcon {...props} />,
  "arrow-caret-down": (props: IconProps) => <ArrowCaretDownIcon {...props} />,
  "arrow-caret-up": (props: IconProps) => <ArrowCaretUpIcon {...props} />,
  "arrow-expand": (props: IconProps) => <ArrowExpandIcon {...props} />,
  "arrow-shrink": (props: IconProps) => <ArrowShrinkIcon {...props} />,
  "arrows-horizontal-left-top-grey": (props: IconProps) => (
    <ArrowsHorizontalLeftTopGreyIcon {...props} />
  ),
  "pagemarker-dot": (props: IconProps) => <PageMarkerDot {...props} />,
  "pagemarker-active": (props: IconProps) => <PageMarkerActive {...props} />,
  plus: (props: IconProps) => <PlusIcon {...props} />,
  user: (props: IconProps) => <UserIcon {...props} />,
  "user-two": (props: IconProps) => <UserTwoIcon {...props} />,
  "user-three": (props: IconProps) => <UserThreeIcon {...props} />,
  "user-tick": (props: IconProps) => <UserTickIcon {...props} />,
  "user-plus": (props: IconProps) => <UserPlusIcon {...props} />,
  "user-minus": (props: IconProps) => <UserMinusIcon {...props} />,
  "user-cross": (props: IconProps) => <UserCrossIcon {...props} />,
  "user-circle": (props: IconProps) => <UserCircle {...props} />,
  "user-card": (props: IconProps) => <UserCardIcon {...props} />,
  "user-card-slim": (props: IconProps) => <UserCardSlimIcon {...props} />,
  "users-group": (props: IconProps) => <UsersGroupIcon {...props} />,
  "circle-tick": (props: IconProps) => <CircleTick {...props} />,
  "circle-check-solid": (props: IconProps) => <CircleCheckSolid {...props} />,
  "circle-badge-check-outline": (props: IconProps) => (
    <CircleBadgeCheckOutlineIcon {...props} />
  ),
  "circle-badge-check-solid": (props: IconProps) => (
    <CircleBadgeCheckSolidIcon {...props} />
  ),
  "circle-badge-warning-outline": (props: IconProps) => (
    <CircleBadgeWarningOutlineIcon {...props} />
  ),
  "circle-backslash-outline": (props: IconProps) => (
    <CircleBackslashIcon {...props} />
  ),
  "shield-badge-check": (props: IconProps) => <ShieldCheckIcon {...props} />,
  "square-tick-large": (props: IconProps) => <SquareTickLargeIcon {...props} />,
  "external-link": (props: IconProps) => <ExternalLinkIcon {...props} />,
  "visible-eye": (props: IconProps) => <VisibleEyeIcon {...props} />,
  "settings-gear": (props: IconProps) => <SettingsGear {...props} />,
  image: (props: IconProps) => <ImageIcon {...props} />,
  "image-large": (props: IconProps) => <ImageLargeIcon {...props} />,
  "arrow-right-lg": (props: IconProps) => <ArrowRightLGIcon {...props} />,
  close: (props: IconProps) => <CloseIcon {...props} />,
  "close-large": (props: IconProps) => <CloseLargeIcon {...props} />,
  list: (props: IconProps) => <ListIcon {...props} />,
  "building-outline": (props: IconProps) => <BuildingOutlineIcon {...props} />,
  "edit-pencil-line1": (props: IconProps) => <EditIconPencilLine1 {...props} />,
  play: (props: IconProps) => <PlayIcon {...props} />,
  hexagon1: (props: IconProps) => <Hexagon1 {...props} />,
  "profile-photo-invalid": (props: IconProps) => (
    <ProfilePhotoInvalid {...props} />
  ),
  "profile-photo-valid": (props: IconProps) => <ProfilePhotoValid {...props} />,
  "trash-full": (props: IconProps) => <TrashFull {...props} />,
  "logo-positive": (props: IconProps) => <LogoPOS {...props} />,
  "logo-negative": (props: IconProps) => <LogoNEG {...props} />,
  "warning-circle": (props: IconProps) => <CircleWarning {...props} />,
  "warning-circle-help": (props: IconProps) => <WarningCircleHelp {...props} />,
  "warning-info": (props: IconProps) => <WarningInfo {...props} />,
  "warning-octagon": (props: IconProps) => <OctagonWarning {...props} />,
  "warning-triangle": (props: IconProps) => <TriangleWarning {...props} />,
  clock: (props: IconProps) => <ClockIcon {...props} />,
  "clock-solid": (props: IconProps) => <ClockSolidIcon {...props} />,
  "clock-warning-outline": (props: IconProps) => (
    <ClockWarningOutlineIcon {...props} />
  ),
  "clock-cross-outline": (props: IconProps) => (
    <ClockCrossOutlineIcon {...props} />
  ),
  timer: (props: IconProps) => <TimerIcon {...props} />,
  calendar: (props: IconProps) => <CalendarIcon {...props} />,
  "calendar-close": (props: IconProps) => <CalendarCloseIcon {...props} />,
  "calendar-days": (props: IconProps) => <CalendarDaysIcon {...props} />,
  "calendar-event": (props: IconProps) => <CalendarEventIcon {...props} />,
  crop: (props: IconProps) => <Crop {...props} />,
  "requirement-type": (props: IconProps) => <RequirementType {...props} />,
  "all-checked": (props: IconProps) => <AllCheckedIcon {...props} />,
  camera: (props: IconProps) => <CameraIcon {...props} />,
  file: (props: IconProps) => <File {...props} />,
  "file-upload": (props: IconProps) => <FileUploadIcon {...props} />,
  "file-upload-large": (props: IconProps) => <FileUploadLargeIcon {...props} />,
  "empty-tile-large": (props: IconProps) => <EmptyTileLargeIcon {...props} />,
  "processing-csv-large": (props: IconProps) => (
    <ProcessingCsvLarge {...props} />
  ),
  "import-records-large": (props: IconProps) => (
    <ImportRecordsLarge {...props} />
  ),
  "card-check-large": (props: IconProps) => <CardCheckLarge {...props} />,
  "new-credentials-large": (props: IconProps) => (
    <NewCredentialsLarge {...props} />
  ),
  "qr-code": (props: IconProps) => <QRCodeIcon {...props} />,
  "no-results-large": (props: IconProps) => <NoResultsLarge {...props} />,
  download: (props: IconProps) => <DownloadIcon {...props} />,
  "cloud-download": (props: IconProps) => <CloudDownloadIcon {...props} />,
  "nav-dashboard": (props: IconProps) => <NavDashboardIcon {...props} />,
  "nav-onboarding": (props: IconProps) => <NavOnboardingIcon {...props} />,
  "nav-members": (props: IconProps) => <NavMembersIcon {...props} />,
  "nav-credentials": (props: IconProps) => <NavCredentialsIcon {...props} />,
  "nav-locations": (props: IconProps) => <NavLocationsIcon {...props} />,
  "nav-location-dashboard": (props: IconProps) => (
    <NavLocationDashboardIcon {...props} />
  ),
  "nav-location-live-view": (props: IconProps) => (
    <NavLocationLiveViewIcon {...props} />
  ),
  "nav-location-new": (props: IconProps) => <NavLocationNewIcon {...props} />,
  "nav-organisations": (props: IconProps) => (
    <NavOrganisationsIcon {...props} />
  ),
  "nav-cards": (props: IconProps) => <NavCardsIcon {...props} />,
  "nav-members-new": (props: IconProps) => <NavMembersNewIcon {...props} />,
  "nav-members-import": (props: IconProps) => (
    <NavMembersImportIcon {...props} />
  ),
  "nav-organisations-new": (props: IconProps) => (
    <NavOrganisationsNewIcon {...props} />
  ),
  "nav-credentials-new": (props: IconProps) => (
    <NavCredentialsNewIcon {...props} />
  ),
  "nav-credentials-assign": (props: IconProps) => (
    <NavCredentialsAssignIcon {...props} />
  ),
  "nav-cards-new-card": (props: IconProps) => (
    <NavCardsNewCardIcon {...props} />
  ),
  "nav-cards-new-template": (props: IconProps) => (
    <NavCardsNewTemplateIcon {...props} />
  ),
  "nav-cards-templates": (props: IconProps) => (
    <NavCardsTemplatesIcon {...props} />
  ),
  "nav-cards-orders": (props: IconProps) => <NavCardsOrdersIcon {...props} />,
  "nav-templates": (props: IconProps) => <NavTemplatesIcon {...props} />,
  "nav-roles": (props: IconProps) => <NavRolesIcon {...props} />,
  "selected-pin": (props: IconProps) => <SelectedPinIcon {...props} />,
  "shopping-cart": (props: IconProps) => <ShoppingCartIcon {...props} />,
  checked: (props: IconProps) => <CheckIcon {...props} />,
  "menu-grid-big": (props: IconProps) => <MenuGridBigIcon {...props} />,
  "menu-hamburger": (props: IconProps) => <MenuHamburgerIcon {...props} />,
  "more-horizontal": (props: IconProps) => <MoreHorizontalIcon {...props} />,
  "more-vertical": (props: IconProps) => <MoreVerticalIcon {...props} />,
  logo: (props: IconProps) => <LogoIcon {...props} />,
  "cropped-logo": (props: IconProps) => <CroppedLogoIcon {...props} />,
  "processing-order": (props: IconProps) => <ProcessingOrderIcon {...props} />,
  note: (props: IconProps) => <NoteIcon {...props} />,
  notebook: (props: IconProps) => <NotebookIcon {...props} />,
  "people-crowd": (props: IconProps) => <PeopleCrowdIcon {...props} />,
  "people-crowd-outline": (props: IconProps) => (
    <PeopleCrowdOutlineIcon {...props} />
  ),
  "people-group": (props: IconProps) => <PeopleGroupIcon {...props} />,
  "people-group-outline": (props: IconProps) => (
    <PeopleGroupOutlineIcon {...props} />
  ),
  dashboard: (props: IconProps) => <DashboardIcon {...props} />,
  logout: (props: IconProps) => <LogoutIcon {...props} />,
  "edit-table": (props: IconProps) => <EditTableIcon {...props} />,
  "paper-plane": (props: IconProps) => <PaperPlaneIcon {...props} />,
  "remove-minus": (props: IconProps) => <RemoveMinusIcon {...props} />,
  "circle-check": (props: IconProps) => <CircleCheckIcon {...props} />,
  "circle-close": (props: IconProps) => <CircleCloseIcon {...props} />,
  "credential-card": (props: IconProps) => <CredentialCardIcon {...props} />,
  search: (props: IconProps) => <SearchIcon {...props} />,
  "credential-issuance-finish": (props: IconProps) => (
    <CredentialIssuanceFinishIcon {...props} />
  ),
  "wallet-identity": (props: IconProps) => (
    <WalletCredentialIdentityIcon {...props} />
  ),
  "wallet-assessment": (props: IconProps) => (
    <WalletCredentialAssessmentIcon {...props} />
  ),
  "wallet-unit-standard": (props: IconProps) => (
    <WalletCredentialUnitStandardIcon {...props} />
  ),
  "wallet-training": (props: IconProps) => (
    <WalletCredentialTrainingIcon {...props} />
  ),
  "wallet-induction": (props: IconProps) => (
    <WalletCredentialInductionIcon {...props} />
  ),
  "wallet-address": (props: IconProps) => (
    <WalletCredentialAddressIcon {...props} />
  ),
  "wallet-equipment": (props: IconProps) => (
    <WalletCredentialEquipmentIcon {...props} />
  ),
  "wallet-course": (props: IconProps) => (
    <WalletCredentialCourseIcon {...props} />
  ),
  "wallet-license": (props: IconProps) => (
    <WalletCredentialLicenseIcon {...props} />
  ),
  "wallet-document": (props: IconProps) => (
    <WalletCredentialDocumentIcon {...props} />
  ),
  "wallet-membership": (props: IconProps) => (
    <WalletCredentialMembershipIcon {...props} />
  ),
  "wallet-missing": (props: IconProps) => (
    <WalletCredentialMissingIcon {...props} />
  ),
  "sort-ascending": (props: IconProps) => <SortAscendingIcon {...props} />,
  "sort-descending": (props: IconProps) => <SortDescendingIcon {...props} />,
  "status-badge": (props: IconProps) => <StatusBadgeIcon {...props} />,
  "status-badge-left": (props: IconProps) => <StatusBadgeLeftIcon {...props} />,
  mail: (props: IconProps) => <MailIcon {...props} />,
  "drag-vertical": (props: IconProps) => <DragVerticalIcon {...props} />,
  lock: (props: IconProps) => <LockIcon {...props} />,
  "issue-success": (props: IconProps) => <IssueSuccessIcon {...props} />,
  archive: (props: IconProps) => <ArchiveIcon {...props} />,
  undo: (props: IconProps) => <UndoIcon {...props} />,
  "darker-issue-success": (props: IconProps) => (
    <DarkerIssueSuccess {...props} />
  ),
  ruleset: (props: IconProps) => <RulesetIcon {...props} />,
  "checklist-checked": (props: IconProps) => (
    <ChecklistCheckedIcon {...props} />
  ),
  "view-empty-panel-selection-credential": (props: IconProps) => (
    <ViewEmptyPanelSelectionCredentialIcon {...props} />
  ),
  "view-empty-panel-selection-recipient": (props: IconProps) => (
    <ViewEmptyPanelSelectionRecipientIcon {...props} />
  ),
  "file-download": (props: IconProps) => <FileDownloadIcon {...props} />,
  copy: (props: IconProps) => <CopyIcon {...props} />,
  "checkbox-inner-tick": (props: IconProps) => (
    <CheckboxInnerTickIcon {...props} />
  ),
  "arrow-reload": (props: IconProps) => <ArrowReload {...props} />,
  "arrow-reset": (props: IconProps) => <ArrowResetIcon {...props} />,
  "filter-options": (props: IconProps) => <FilterOptionsIcon {...props} />,
  "map-pin": (props: IconProps) => <MapPinIcon {...props} />,
  "issue-credential": (props: IconProps) => <IssueCredentialIcon {...props} />,
  "location-ruleset": (props: IconProps) => <LocationRulesetIcon {...props} />,
  "map-pin-filled": (props: IconProps) => <MapPinFilledIcon {...props} />,
  "credential-issuance-hex": (props: IconProps) => (
    <CredentialIssuanceHexIcon {...props} />
  ),
  worker: (props: IconProps) => <WorkerIcon {...props} />,
  "event-ruleset": (props: IconProps) => <EventRulesetIcon {...props} />,
};
